import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { Room } from './ListTypes'

const DeleteRoomPopup: React.FC<{
  onClose: () => void
  onConfirm: (keepProducts: boolean) => void
  room: Room
  numProducts: number
}> = ({
  onClose,
  onConfirm,
  room,
  numProducts,
}) => {
  return (
    <Popup onClose={onClose}>
      <div className="title">
        Remove Room <strong>{room.name}</strong>
      </div>
      <div className="subtitle">
        Do you want to keep the {
          numProducts === 1 ? 'product' : `${numProducts} products`
        } that {
          numProducts === 1 ? 'is' : 'are'
        } in the room?
        <br></br>
      </div>

      <div className="buttonStack">
        <div className="buttonRow">
          <Button
            onClick={() => onConfirm(true)}
          >
            Keep {numProducts === 1 ? 'it' : 'them'}
          </Button>
          <Button
            buttonStyle="redStroke"
            onClick={() => onConfirm(false)}
          >
            Remove {numProducts === 1 ? 'it' : 'them'}
          </Button>
        </div>
        <Button
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Popup>
  )
}

export default DeleteRoomPopup
